import { render, staticRenderFns } from "./MMP_Attributes.vue?vue&type=template&id=7e06f8dd&scoped=true&"
import script from "./MMP_Attributes.vue?vue&type=script&lang=js&"
export * from "./MMP_Attributes.vue?vue&type=script&lang=js&"
import style0 from "./MMP_Attributes.vue?vue&type=style&index=0&id=7e06f8dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e06f8dd",
  null
  
)

export default component.exports